import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Button = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 320px;
  padding: 16px 24px;
  background: white;
  color: black;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: ${({ theme }) => theme.typography.button.fontSize};
  font-weight: ${({ theme }) => theme.typography.button.fontWeight};
  gap: 12px;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.md};
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    // transform: none;
  }
`;

const AppleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.52-3.2 0-.83.38-1.23.42-1.96.07-2.89-1.33-4.31-6.84-2.81-9.94.87-1.81 2.47-2.71 4.22-2.71.92 0 1.78.34 2.54.53.6.15 1.16.29 1.63.29.39 0 .89-.12 1.44-.25.83-.2 1.76-.43 2.77-.21 1.06.23 1.96.78 2.54 1.56-2.21 1.4-1.87 4.94.34 6.06-.62 1.61-1.42 3.21-2.43 4.2zM14.13 4.73c-.51.46-.94.53-1.45.53-.06 0-.12 0-.18-.01.07-1.58.87-2.87 1.99-3.49.55-.31 1.24-.51 1.97-.51.05 1.22-.39 2.29-1.07 3.02-.49.52-1.08.83-1.26.46z"/>
  </svg>
);

const LoadingSpinner = styled(motion.div)`
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: black;
  border-radius: 50%;
`;

export const SignInWithApple = ({ onClick, disabled }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {disabled ? (
        <LoadingSpinner 
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
      ) : (
        <>
          <AppleIcon />
          Sign in with Apple
        </>
      )}
    </Button>
  );
}; 